var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobilecamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 39,
    viewBox: "0 0 32 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 18.9961C17.308 18.9961 20 16.3061 20 12.9961C20 9.68809 17.308 6.99609 14 6.99609C10.692 6.99609 8 9.68809 8 12.9961C8 16.3041 10.692 18.9961 14 18.9961ZM14 10.9961C15.102 10.9961 16 11.8941 16 12.9961C16 14.0981 15.102 14.9961 14 14.9961C12.898 14.9961 12 14.0981 12 12.9961C12 11.8941 12.898 10.9961 14 10.9961Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 8.99609C26 10.1007 25.1046 10.9961 24 10.9961C22.8954 10.9961 22 10.1007 22 8.99609C22 7.89152 22.8954 6.99609 24 6.99609C25.1046 6.99609 26 7.89152 26 8.99609Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 0.996094H4C1.794 0.996094 0 2.78809 0 4.99609V38.9961H32V4.99609C32 2.78809 30.206 0.996094 28 0.996094ZM4 34.9961V4.99609H28V34.9961H4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilecamera);
export default __webpack_public_path__ + "static/media/Mobile camera.36d76dc69a6f3070ca68837bec5619cb.svg";
export { ForwardRef as ReactComponent };